import { render, staticRenderFns } from "./th-2line-header.vue?vue&type=template&id=5da4f2e2&"
import script from "./th-2line-header.vue?vue&type=script&lang=js&"
export * from "./th-2line-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports